import CONSTANTS from '../constants'
import { postRequest } from '../../services'
import { APICONFIG } from '../apiConfig'

// Calls the API to get user token
export const postCitationCardDetails = (creds) => (dispatch) => {
    dispatch({ type: CONSTANTS.POST_CITATION_CARD_REQUEST })
    return postRequest(APICONFIG.postCitationUrl, creds).then((res) => {
        dispatch({ type: CONSTANTS.POST_CITATION_CARD_SUCCESS, data: res })
        return res
    }).catch((err) => {
        dispatch({ type: CONSTANTS.POST_CITATION_CARD_FAILURE })
        return err
    })
}

export const postBeforePayment = (creds) => (dispatch) => {
    dispatch({ type: CONSTANTS.BEFORE_PASS_PAYMENT_INITIAL_REQUEST })
    return postRequest(APICONFIG.postBeforePayemntUrl, creds).then((res) => {
        dispatch({ type: CONSTANTS.BEFORE_PASS_PAYMENT_INITIAL_SUCCESS, data: res })
        return res
    }).catch((err) => {
        dispatch({ type: CONSTANTS.BEFORE_PASS_PAYMENT_INITIAL_FAILURE })
        return err
    })
}

export const postAfterPayment = (creds) => (dispatch) => {
    dispatch({ type: CONSTANTS.AFTER_PASS_PAYMENT_INITIAL_REQUEST })
    return postRequest(APICONFIG.postAfterPayemntUrl, creds).then((res) => {
        dispatch({ type: CONSTANTS.AFTER_PASS_PAYMENT_INITIAL_SUCCESS, data: res })
        return res
    }).catch((err) => {
        dispatch({ type: CONSTANTS.AFTER_PASS_PAYMENT_INITIAL_FAILURE })
        return err
    })
}


// get details
export const getCitationDetails = (creds) => (dispatch) => {
    dispatch({ type: CONSTANTS.GET_CITATION_DETAILS_REQUEST })
    return postRequest(APICONFIG.getCitationUrl, creds).then((res) => {
        dispatch({ type: CONSTANTS.GET_CITATION_DETAILS_SUCCESS, data: res?.data })
        return res
    }).catch((err) => {
        dispatch({ type: CONSTANTS.GET_CITATION_DETAILS_FAILURE })
        return err
    })
}


// appeal create 
export const postCreateAppeal = (creds) => (dispatch) => {
    dispatch({ type: CONSTANTS.POST_CREATE_APPEAL_REQUEST })
    return postRequest(APICONFIG.createAppealUrl, creds).then((res) => {
        dispatch({ type: CONSTANTS.POST_CREATE_APPEAL_SUCCESS, data: res?.data })
        return res
    }).catch((err) => {
        dispatch({ type: CONSTANTS.POST_CREATE_APPEAL_FAILURE })
        return err
    })
}

// void create 
export const postVoidAppeal = (creds) => (dispatch) => {
    const payload = {...creds, 'device_type': 'web'}
    dispatch({ type: CONSTANTS.POST_CREATE_VOID_REQUEST })
    return postRequest(APICONFIG.createVoidUrl, payload).then((res) => {
        dispatch({ type: CONSTANTS.POST_CREATE_VOID_SUCCESS, data: res?.data })
        return res
    }).catch((err) => {
        dispatch({ type: CONSTANTS.POST_CREATE_VOID_FAILURE })
        return err
    })
}
